"use strict";

var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty");

var _toConsumableArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/toConsumableArray");

var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _antd = require("antd");

var _icons = require("@ant-design/icons");

var _lodash = require("lodash");

var _htmlReactParser = _interopRequireDefault(require("html-react-parser"));

var _immer = _interopRequireDefault(require("immer"));

var _Input = _interopRequireDefault(require("../Input"));

var _ListItem = _interopRequireDefault(require("../ListItem"));

var _Tag = _interopRequireDefault(require("../Tag"));

var _utils = require("../../utils");

var _store = require("../../store");

var _theme = require("../../theme");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var Menu = function Menu(props) {
  var _sites$siteID, _sites$siteID2;

  var _props$value = props.value,
      value = _props$value === void 0 ? [] : _props$value,
      onChange = props.onChange;

  var _ref4 = (0, _store.useStore)(),
      _ref5 = _slicedToArray(_ref4, 1),
      _ref5$ = _ref5[0],
      _ref5$$cmsState = _ref5$.cmsState,
      sites = _ref5$$cmsState.sites,
      siteID = _ref5$$cmsState.siteID,
      siteHasChanged = _ref5$.editorState.siteHasChanged;

  var _ref6 = (0, _react.useState)([]),
      _ref7 = _slicedToArray(_ref6, 2),
      editing = _ref7[0],
      setEditing = _ref7[1];

  var _ref8 = (0, _react.useState)({
    active: false,
    node: null
  }),
      _ref9 = _slicedToArray(_ref8, 2),
      dialog = _ref9[0],
      setDialog = _ref9[1];

  var _ref10 = (0, _react.useState)('Pages'),
      _ref11 = _slicedToArray(_ref10, 2),
      filter = _ref11[0],
      setFilter = _ref11[1];

  var _ref12 = (0, _react.useState)([]),
      _ref13 = _slicedToArray(_ref12, 2),
      items = _ref13[0],
      setItems = _ref13[1];

  var _ref14 = (0, _react.useState)({
    title: '',
    url: ''
  }),
      _ref15 = _slicedToArray(_ref14, 2),
      customLink = _ref15[0],
      setCustomLink = _ref15[1]; // When a post is saved while a menu item is open, we need to manually reset the editing array to allow dragging


  (0, _react.useEffect)(function () {
    !siteHasChanged && setEditing([]);
  }, [siteHasChanged]);
  (0, _react.useEffect)(function () {
    if (value && Array.isArray(value)) {
      setItems((0, _utils.deepCopyTree)(value));
    }
  }, [value]); // Get posts by filter

  var postType = Object.values((_sites$siteID = sites[siteID]) === null || _sites$siteID === void 0 ? void 0 : _sites$siteID.postTypes).find(function (o) {
    return o.title === filter;
  });
  var posts = postType === null || postType === void 0 ? void 0 : postType.posts; // Function provided by Ant Design

  var onDrop = function onDrop(info) {
    var dropKey = info.node.props.eventKey;
    var dragKey = info.dragNode.props.eventKey;
    var dropPos = info.node.props.pos.split('-');
    var dropPosition = info.dropPosition - Number(dropPos[dropPos.length - 1]);

    var loop = function loop(data, key, callback) {
      for (var i = 0; i < data.length; i++) {
        if (data[i].key === key) {
          return callback(data[i], i, data);
        }

        if (data[i].children) {
          loop(data[i].children, key, callback);
        }
      }
    };

    var data = _toConsumableArray(items); // Find dragObject


    var dragObj;
    loop(data, dragKey, function (item, index, arr) {
      arr.splice(index, 1);
      dragObj = item;
    });

    if (!info.dropToGap) {
      // Drop on the content
      loop(data, dropKey, function (item) {
        item.children = item.children || []; // where to insert

        item.children.push(dragObj);
      });
    } else if ((info.node.props.children || []).length > 0 && // Has children
    info.node.props.expanded && // Is expanded
    dropPosition === 1 // On the bottom gap
    ) {
        loop(data, dropKey, function (item) {
          item.children = item.children || []; // where to insert

          item.children.unshift(dragObj);
        });
      } else {
      var ar;
      var i;
      loop(data, dropKey, function (item, index, arr) {
        ar = arr;
        i = index;
      });

      if (dropPosition === -1) {
        ar.splice(i, 0, dragObj);
      } else {
        ar.splice(i + 1, 0, dragObj);
      }
    }

    onChange(data);
  };

  var handleUpdate = function handleUpdate(e, name, key) {
    var updateItem = function updateItem(parentNode, child, params) {
      if (child.key === params.key) {
        return _objectSpread(_objectSpread({}, child), {}, _defineProperty({}, name, params.value));
      }

      return child;
    };

    var newItems = (0, _utils.recursivelyUpdateTree)({
      children: items
    }, updateItem, {
      key: key,
      value: e.target.value
    });
    onChange(newItems);
  };

  var handleRemove = function handleRemove(key) {
    var newItems = (0, _utils.removeFromTree)({
      children: _toConsumableArray(items)
    }, key);
    onChange(newItems.children); // Remove key from array

    var nextValue = (0, _immer.default)(editing, function (draft) {
      if (draft.includes(key)) {
        draft = draft.filter(function (k) {
          return k !== key;
        });
      }

      return draft;
    });
    setEditing(nextValue);
  };

  var handleAddCustomLink = function handleAddCustomLink() {
    if (!customLink.title || !customLink.url) {
      return;
    }

    onChange([].concat(_toConsumableArray(items), [_objectSpread(_objectSpread({
      key: (0, _utils.generateRandomString)()
    }, customLink), {}, {
      postTypeID: null,
      postID: null,
      children: []
    })]));
    setCustomLink({
      title: '',
      url: ''
    });
  };

  var handleToggleCollapse = function handleToggleCollapse(key) {
    var nextValue = (0, _immer.default)(editing, function (draft) {
      if (draft.includes(key)) {
        draft = draft.filter(function (k) {
          return k !== key;
        });
      } else {
        draft.push(key);
      }

      return draft;
    });
    setEditing(nextValue);
  };

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(Container, null, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_antd.Tree, {
    className: "draggable-tree",
    draggable: editing.length === 0,
    showLine: true,
    blockNode: true,
    onDrop: onDrop,
    treeData: items,
    titleRender: function titleRender(node) {
      return /*#__PURE__*/_react.default.createElement(_antd.Collapse, {
        ghost: true,
        onChange: function onChange() {
          return handleToggleCollapse(node.key);
        }
      }, /*#__PURE__*/_react.default.createElement(_antd.Collapse.Panel, {
        header: /*#__PURE__*/_react.default.createElement("span", {
          style: {
            cursor: editing.length === 0 ? 'grab' : 'not-allowed'
          }
        }, (0, _htmlReactParser.default)(node.title || ' ')),
        showArrow: false
      }, /*#__PURE__*/_react.default.createElement(_antd.Space, {
        direction: "vertical"
      }, /*#__PURE__*/_react.default.createElement(_Input.default, {
        label: "title",
        value: node.title,
        onChange: function onChange(e) {
          return handleUpdate(e, 'title', node.key);
        }
      }), /*#__PURE__*/_react.default.createElement(_Input.default, {
        label: "Url",
        value: node.url,
        onChange: function onChange(e) {
          return handleUpdate(e, 'url', node.key);
        },
        disabled: node.postTypeID
      }), /*#__PURE__*/_react.default.createElement(_antd.Button, {
        size: "small",
        danger: true,
        children: "Remove",
        onClick: function onClick() {
          return handleRemove(node.key);
        },
        disabled: node.children.length > 0
      }))));
    }
  })), /*#__PURE__*/_react.default.createElement(AddButton, {
    onClick: function onClick() {
      return setDialog({
        active: true,
        node: null
      });
    }
  }, /*#__PURE__*/_react.default.createElement(_icons.PlusOutlined, null)))), /*#__PURE__*/_react.default.createElement(_antd.Modal, {
    title: "Add item",
    visible: dialog.active,
    onCancel: function onCancel() {
      return setDialog({
        active: false,
        node: null
      });
    },
    width: 400,
    footer: null
  }, /*#__PURE__*/_react.default.createElement(_antd.Tabs, {
    defaultActiveKey: filter,
    onChange: function onChange(v) {
      return setFilter(v);
    }
  }, Object.values((_sites$siteID2 = sites[siteID]) === null || _sites$siteID2 === void 0 ? void 0 : _sites$siteID2.postTypes).map(function (o) {
    return /*#__PURE__*/_react.default.createElement(_antd.Tabs.TabPane, {
      key: o.title,
      tab: o.title.toUpperCase()
    });
  }), /*#__PURE__*/_react.default.createElement(_antd.Tabs.TabPane, {
    key: 'custom-link',
    tab: 'CUSTOM LINK'
  })), /*#__PURE__*/_react.default.createElement("div", null, filter !== 'custom-link' && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (0, _lodash.isEmpty)(posts) ? /*#__PURE__*/_react.default.createElement(EmptyContainer, null, /*#__PURE__*/_react.default.createElement(_antd.Empty, {
    imageStyle: {
      height: 120
    }
  })) : Object.values(posts).filter(function (_ref) {
    var status = _ref.status;
    return status !== 'trash';
  }).map(function (_ref2) {
    var id = _ref2.id,
        title = _ref2.title,
        status = _ref2.status,
        postTypeID = _ref2.postTypeID;
    var badges = [];

    if (status === 'draft') {
      badges.push( /*#__PURE__*/_react.default.createElement(_Tag.default, {
        key: "status",
        children: status
      }));
    }

    return /*#__PURE__*/_react.default.createElement(StyledListItem, {
      key: id,
      title: title,
      status: badges,
      disabled: status === 'draft',
      onClick: function onClick() {
        var _sites$siteID3;

        return status === 'publish' && onChange([].concat(_toConsumableArray(items), [{
          key: (0, _utils.generateRandomString)(),
          title: title,
          postTypeID: postTypeID,
          postID: id,
          children: [],
          url: (0, _utils.generateSlug)(postType, id, sites === null || sites === void 0 ? void 0 : (_sites$siteID3 = sites[siteID]) === null || _sites$siteID3 === void 0 ? void 0 : _sites$siteID3.frontPage, true)
        }]));
      }
    });
  })), filter === 'custom-link' && /*#__PURE__*/_react.default.createElement(_antd.Space, {
    direction: "vertical",
    size: 20
  }, /*#__PURE__*/_react.default.createElement(_Input.default, {
    label: "Title",
    value: customLink.title,
    onChange: function onChange(e) {
      return setCustomLink(_objectSpread(_objectSpread({}, customLink), {}, {
        title: e.target.value
      }));
    }
  }), /*#__PURE__*/_react.default.createElement(_Input.default, {
    label: "Url",
    value: customLink.url,
    onChange: function onChange(e) {
      return setCustomLink(_objectSpread(_objectSpread({}, customLink), {}, {
        url: e.target.value
      }));
    },
    placeholder: "https://"
  }), /*#__PURE__*/_react.default.createElement(_antd.Button, {
    style: {
      marginBottom: 20
    },
    children: "Add",
    type: "primary",
    onClick: handleAddCustomLink
  })))));
};

var Container = _styledComponents.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  && {\n    overflow: auto;\n\n    .ant-tree {\n      background-color: transparent;\n    }\n\n    .ant-tree-list-holder {\n      padding-top: 6px;\n    }\n\n    .ant-collapse {\n      background-color: transparent;\n      border: none !important;\n    }\n\n    .ant-collapse-header {\n      padding: 5px !important;\n    }\n\n    .ant-tree-node-content-wrapper {\n      padding: 0;\n\n      &:hover {\n        background-color: transparent;\n      }\n    }\n    .ant-tree-node-content-wrapper.ant-tree-node-selected {\n      background-color: transparent;\n    }\n\n    .ant-collapse-content-box {\n      padding-top: 0 !important;\n    }\n\n    .ant-collapse-content > .ant-collapse-content-box {\n      border-bottom: none;\n      background: transparent;\n    }\n\n    .rst__rowContents {\n      min-width: 150px;\n    }\n  }\n"])));

var StyledListItem = (0, _styledComponents.default)(_ListItem.default)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  .ant-card {\n    box-shadow: none !important;\n    background: #fff;\n    border: 1px solid #d9d9d9;\n    margin-bottom: 4px;\n\n    ", "\n  }\n\n  .ant-card-body {\n    padding: 0 16px;\n  }\n\n  .ant-list-item-meta-title {\n    margin: 0;\n    line-height: 1;\n  }\n\n  .ant-typography strong {\n    font-weight: 400;\n  }\n"])), function (_ref3) {
  var disabled = _ref3.disabled;
  return disabled ? (0, _styledComponents.css)(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n            cursor: not-allowed;\n            opacity: 0.4;\n          "]))) : (0, _styledComponents.css)(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n            cursor: pointer;\n            opacity: 1;\n\n            &:hover {\n              opacity: 0.8;\n            }\n          "])));
});

var EmptyContainer = _styledComponents.default.div(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  text-align: center;\n"])));

var AddButton = _styledComponents.default.div(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 46px;\n  width: 100%;\n  border: 1px solid transparent;\n  cursor: pointer;\n  transition: ease-in all 0.2s;\n\n  &:hover {\n    border-color: ", ";\n  }\n"])), _theme.colors.tertiary);

var _default = Menu;
exports.default = _default;